import Add from "../../table/Add";
import ApiService from "../../../services/apiService";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { useEffect } from "react";
import { method } from "lodash";


const AddBeneficiary = () =>{
    const navigate = useNavigate();
    const [chackData, setChackData] = useState<any>([]);
    const[wua,setwua] = useState();
    const[schemevillage,setschemevillage] = useState();
    const[distributary,setdistributary] = useState();

    const getWua = async() =>{
         try{
             const response = await ApiService.axiosApi(`/wua`,{
                 method:'GET'
             })
             if(response.success){
                 setwua(response.data)
             }else{
                console.log('unable to get ')
             }
         } catch(e){
            console.log(e)
         }
  
    }

    const fetchSchemeVillage = async ()=>{
        try{
        const response = await ApiService.axiosApi(`/schemevillage`,{
            method: 'GET',
            params:{
                pageNumber :0,
                pageSize:0
           }
        });
          if(response.success){
            setschemevillage(response.data.data);
          }
        }catch(error:any){
            toast.error(error.message || "Failed to fetch Scheme Village");
        }
    }


    const fetchDistributaryData = async ()=>{
        try{
        const response = await ApiService.axiosApi(`/dzone`,{
            method: 'GET',
            params:{
                pageNumber :0,
                pageSize:0
           }
        });
        if(response.success){
            setdistributary(response.data.data); 
        }
    }catch(error:any){
        toast.error(error.message || "Failed to fetch Distributary Zone");
    }
    }

 useEffect(()=>{
      getWua();
      fetchDistributaryData();
      fetchSchemeVillage();
 },[])
    
    const handleSubmit = async (data: any) =>{
        try{
            const response = await ApiService.axiosApi(`/beneficiarylist`,{
                method: 'Post',
                data: data
            });
            if(response.success){
                toast.success(response.message || "Beneficiary List Added Successfully")
                navigate(-1)
            }else{
                toast.error(response.message || "Failed to add Beneficiary List")
            }
        }catch(error: any){
            toast.error(error.message || "Failed to add Beneficiary List")
        }
    }

    useEffect(()=>{
        const fetchChackData = async ()=>{              
            try{
                const response = await ApiService.axiosApi(`/chack`,{
                    method: 'GET',
                    params:{
                        pageNumber :0,
                        pageSize:0
                   }
                });
                if(response.success){
                    setChackData(response.data.data);
                }
            }catch(error:any){
            toast.error(error.message || "Failed to fetch Chack Data");
        }   }
        fetchChackData();
    },[]);  
 

    return(
        <Add 
        title={"Add Beneficiary"}
        parentTitle={"Beneficiary List"}
        onSubmit={handleSubmit}
        fields={[
           
              {
                 name:"CcaArea",
                 label:"C.C.A Acre",
                 type:"text"
              },
              {
                 name:"NameOfBeneficiary",
                 label:"Name Of Beneficiary",
                 type:"text"
              },
               {
                name:"Plot_No",
                 label:"Plot",
                 type:"text"
               },
              {
                name: "ChakName",
                label: "Chak",
                isDropdown: true,
                dropdownData: chackData,
                dropdownLabel: "chackName",
                idFieldName: "chakId"
      
            }
            

        ]}
        />
    )
} 
export default AddBeneficiary;